import { Box, Stack, StackSection } from "@origin-digital/ods-core";
import React from "react";
import { CategoriesSection } from "../CategoriesSection";
import { ContactUs } from "../../../../components/ContactUs";

export const ContentSection: React.FC = () => (
  <Box marginBottom={{ xs: "xxlarge", lg: "xxxlarge" }}>
    <Stack space={{ xs: "medium", lg: "xxxlarge" }}>
      <CategoriesSection />
      <ContactUs />
    </Stack>
  </Box>
);
